export default {
  shadowLarge:
    "0 8px 16px 0 rgba(83,79,112,0.10), 0 16px 48px 0 rgba(83,79,112,0.10)",
  shadowMedium:
    "0 4px 8px 0 rgba(83,79,112,0.10), 0 8px 24px 0 rgba(83,79,112,0.10)",
  shadowLight:
    "0 2px 4px 0 rgba(31,165,255,0.10), 0 4px 16px 0 rgba(31,165,255,0.10)",
  none: "none"
}



// WEBPACK FOOTER //
// ./src/lib/theme/shadows.js